<nav class="wizard-nav" aria-label="Steps of the case">
  <!-- The steps of the wizard as one strip of tabs: the open step is raised, the rest sit flat in the strip -->
  <div class="wizard-steps" [class.wizard-steps--few]="steps().length <= 4">
    @for (step of steps(); track step.key; let number = $index) {
      <button
        type="button"
        class="step"
        [class.step--active]="active() === step.key"
        [class.step--next]="active() !== step.key && nextStepKey() === step.key"
        [class.step--locked]="isLocked(step)"
        [class.step--static]="!interactive()"
        [attr.data-state]="showProgress() ? step.state : null"
        [disabled]="!interactive() || isLocked(step)"
        [attr.aria-current]="active() === step.key ? 'step' : null"
        [matTooltip]="showProgress() ? tooltip(step) : ''"
        (click)="selected.emit(step.key)"
      >
        @if (showProgress()) {
          <!-- The number of the step; a tick when it is done, a lock when it has to wait -->
          <span class="step__badge" aria-hidden="true">
            @if (badgeIcon(step); as icon) {
              <mat-icon>{{ icon }}</mat-icon>
            } @else {
              {{ number + 1 }}
            }
          </span>
        }
        <span class="step__label">{{ step.label }}</span>
      </button>
    }
  </div>

  <!-- The work that comes after the wizard (Tasks, Sessions, ...) -->
  @if (sections().length > 0) {
    <div class="wizard-sections">
      @for (section of sections(); track section.key) {
        <button
          type="button"
          class="section"
          [class.section--active]="active() === section.key"
          [attr.aria-current]="active() === section.key ? 'page' : null"
          (click)="selected.emit(section.key)"
        >
          {{ section.label }}
          @if (taskSection() === section.key) {
            <span class="section__dot" [matTooltip]="'Next: ' + taskName()" aria-label="Next task is here"></span>
          }
        </button>
      }
    </div>
  }
</nav>
